(function () {
  function init(root) {
    if (root.dataset.creatorsReady) return;
    root.dataset.creatorsReady = 'true';

    var track = root.querySelector('[data-creators-track]');
    var prev = root.querySelector('[data-creators-prev]');
    var next = root.querySelector('[data-creators-next]');
    var modal = root.querySelector('[data-creators-modal]');
    var modalBody = root.querySelector('[data-creators-modal-body]');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!track) return;

    // Arrows scroll one card at a time and disable at the ends.
    function step() {
      var card = track.querySelector('.evvo-creator-card');
      return card ? card.getBoundingClientRect().width + 16 : track.clientWidth;
    }
    function updateArrows() {
      if (!prev || !next) return;
      var nav = prev.parentElement;
      if (nav) nav.style.visibility = track.scrollWidth > track.clientWidth + 2 ? '' : 'hidden';
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();

    // Muted preview plays only while the card is on screen (and nothing loads before that).
    if (!reduceMotion && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target.querySelector('video');
          if (!video) return;
          if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
            video.muted = !entry.target.classList.contains('is-unmuted');
            var play = video.play();
            if (play && play.catch) play.catch(function () {});
            entry.target.classList.add('is-playing');
          } else {
            video.pause();
            entry.target.classList.remove('is-playing');
          }
        });
      }, { threshold: [0, 0.6] });
      track.querySelectorAll('.evvo-creator-card').forEach(function (card) { io.observe(card); });
    }

    // Tap opens the video full screen with sound and controls.
    function closeModal() {
      var v = modalBody.querySelector('video');
      if (v) v.pause();
      modalBody.innerHTML = '';
      if (modal.open) modal.close();
      document.documentElement.style.overflow = '';
    }
    // Sound toggle: unmute this card in place (and mute any other card that has sound).
    function setSound(card, on) {
      var v = card.querySelector('video');
      var b = card.querySelector('[data-creators-sound]');
      card.classList.toggle('is-unmuted', on);
      if (b) {
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.setAttribute('aria-label', on ? 'Turn sound off' : 'Turn sound on');
      }
      if (!v) return;
      v.muted = !on;
      if (on) {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
        card.classList.add('is-playing');
      }
    }
    track.addEventListener('click', function (e) {
      var sound = e.target.closest('[data-creators-sound]');
      if (sound) {
        e.preventDefault();
        e.stopPropagation();
        var card = sound.closest('.evvo-creator-card');
        var turnOn = !card.classList.contains('is-unmuted');
        track.querySelectorAll('.evvo-creator-card.is-unmuted').forEach(function (c) { setSound(c, false); });
        if (turnOn) setSound(card, true);
        return;
      }
      var btn = e.target.closest('[data-creators-open]');
      if (!btn || !modal) return;
      var source = btn.querySelector('video');
      if (!source) return;
      var v = source.cloneNode(true);
      v.removeAttribute('class');
      if (source.dataset.fullSrc) {
        v.innerHTML = '';
        v.src = source.dataset.fullSrc;
      }
      v.muted = false;
      v.controls = true;
      v.loop = false;
      v.setAttribute('playsinline', '');
      v.preload = 'auto';
      modalBody.innerHTML = '';
      modalBody.appendChild(v);
      track.querySelectorAll('.evvo-creator-card.is-unmuted').forEach(function (c) { setSound(c, false); });
      if (typeof modal.showModal === 'function') modal.showModal(); else modal.setAttribute('open', '');
      document.documentElement.style.overflow = 'hidden';
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    });
    root.querySelector('[data-creators-close]').addEventListener('click', closeModal);
    modal.addEventListener('close', closeModal);
    modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-evvo-creators]').forEach(init);
  }
  initAll(document);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
